var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 8.58667V7.41333C1.33333 6.72 1.9 6.14667 2.6 6.14667C3.80666 6.14667 4.29999 5.29333 3.69333 4.24667C3.34666 3.64667 3.55333 2.86667 4.15999 2.52L5.31333 1.86C5.83999 1.54666 6.52 1.73333 6.83333 2.26L6.90666 2.38666C7.50666 3.43333 8.49333 3.43333 9.09999 2.38666L9.17333 2.26C9.48666 1.73333 10.1667 1.54666 10.6933 1.86L11.8467 2.52C12.4533 2.86667 12.66 3.64667 12.3133 4.24667C11.7067 5.29333 12.2 6.14667 13.4067 6.14667C14.1 6.14667 14.6733 6.71333 14.6733 7.41333V8.58667C14.6733 9.28 14.1067 9.85333 13.4067 9.85333C12.2 9.85333 11.7067 10.7067 12.3133 11.7533C12.66 12.36 12.4533 13.1333 11.8467 13.48L10.6933 14.14C10.1667 14.4533 9.48666 14.2667 9.17333 13.74L9.09999 13.6133C8.49999 12.5667 7.51333 12.5667 6.90666 13.6133L6.83333 13.74C6.52 14.2667 5.83999 14.4533 5.31333 14.14L4.15999 13.48C3.55333 13.1333 3.34666 12.3533 3.69333 11.7533C4.29999 10.7067 3.80666 9.85333 2.6 9.85333C1.9 9.85333 1.33333 9.28 1.33333 8.58667Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.b86701ff02927f97d1ea2e87ff3be595.svg";
export { ForwardRef as ReactComponent };